import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { actions } from "../_redux/favoriteRedux";
import { addFavorite, removeFavorite } from "../_redux/favoriteEndpoint";

function FavoriteButton({ advertId, size = 36, variant = "icon" }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLogged = useSelector((state) => state.auth.isLogged);
  const isFavorite = useSelector((state) =>
    state.favorite.ids.includes(advertId)
  );

  const handleToggle = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!isLogged) {
      toast.info("Favorilere eklemek için giriş yapmalısınız.");
      history.push("/login");
      return;
    }

    if (isFavorite) {
      dispatch(actions.removeFavoriteId(advertId));
      removeFavorite(advertId).catch(() => {
        dispatch(actions.addFavoriteId(advertId));
      });
    } else {
      dispatch(actions.addFavoriteId(advertId));
      addFavorite(advertId).catch(() => {
        dispatch(actions.removeFavoriteId(advertId));
      });
    }
  };

  if (variant === "labeled") {
    return (
      <button
        type="button"
        onClick={handleToggle}
        className="my-3 font-weight-bold"
        style={{
          width: "100%",
          border: isFavorite ? "2px solid #e0245e" : "2px solid #d0d0d0",
          background: isFavorite ? "#fff0f4" : "#fff",
          color: isFavorite ? "#e0245e" : "#444",
          borderRadius: 8,
          padding: "12px 18px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i
          className={isFavorite ? "fa fa-heart" : "fa fa-heart-o"}
          style={{ fontSize: 18, marginRight: 8 }}
        />
        {isFavorite ? "Favorilerimde" : "Favorilere Ekle"}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleToggle}
      aria-label={isFavorite ? "Favorilerden çıkar" : "Favorilere ekle"}
      title={isFavorite ? "Favorilerden çıkar" : "Favorilere ekle"}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(255,255,255,0.92)",
        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        padding: 0,
      }}
    >
      <i
        className={isFavorite ? "fa fa-heart" : "fa fa-heart-o"}
        style={{
          fontSize: size * 0.5,
          color: isFavorite ? "#e0245e" : "#6b6b6b",
        }}
      />
    </button>
  );
}

export default FavoriteButton;
